import { Options, Vue } from 'vue-class-component';

import List from '@/pages/config/system-user/list/list.vue';

@Options({
  name: 'system-user',
  components: {
    'page-list': List,
  },
})
export default class SystemUser extends Vue {
  public isIndexOnly() {
    return /^[/]?system-user[/]?$/.test(this.$router.currentRoute.value.path);
  }
}
